/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function() {
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("You must agree with the terms and conditions of sales to check out.");
        return false;
      }
    });
  
  
  	$('.collapsetext .toggletext').click(function(){
        $(this).siblings('.text_more').slideToggle();
        $(this).parent().find('.toggletext').toggle();
    });
});

function _upselladdMeToCart(e, el) {
	e = e || window.event;
  	e.preventDefault();
    var select = document.getElementById('upsell-product-select-' + el.dataset.variant_id);
    if(select){
      var value = select.options[select.selectedIndex].value;
      console.log(select.options[select.selectedIndex].text);
    }else{
      console.log("ingen variant, produkt id: " + el.dataset.variant_id);
      var value = el.dataset.variant_id;
    }
     
  
    let formData = {
      'items': [
        {
          'id': value,
          'quantity': 1
        }
      ]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((resp) => { 
      return resp.json();
    })
    .then((data) => {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
      }));
    })
    .catch((err) => {
      console.error('Error: ' + err);
    })
}


function _addMeToCart(e, el) {
	e = e || window.event;
  	e.preventDefault();
    var select = document.getElementById('product-select-' + el.dataset.variant_id);
    if(select){
      var value = select.options[select.selectedIndex].value;
      console.log(select.options[select.selectedIndex].text);

    }else{
      console.log("ingen variant, produkt id: " + el.dataset.variant_id);
      var value = el.dataset.variant_id;
    }
     
  
    let formData = {
      'items': [
        {
          'id': value,
          'quantity': 1
        }
      ]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((resp) => { 
      return resp.json();
    })
    .then((data) => {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
      }));
    })
    .catch((err) => {
      console.error('Error: ' + err);
    })
}


/*------------------------------------*\
    Added by Newgency x JRF 15.10.22
    CART-DRAWER MENU + UPSELL
\*------------------------------------*/


function removeGiftitem() {
  setTimeout(function() {
    if (($('.CartItemWrapper, .CartItem.Itemfetch').length > 0) && ($('.CartItemWrapper.Itemfetch.notempty, .CartItem.Itemfetch.notempty').length === 0)) {
      data = { updates: { '42315027513497': 0 } }
      $.ajax({
        type: 'POST', url: '/cart/update.js', data: data, dataType: 'json',
        success: function() { 
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
      });
    }
  }, 1800);
}
function addGiftWraper() {
  data = { "id": '42315027513497', "quantity": 1 }
  $.ajax({
    type: 'POST', url: '/cart/add.js', data: data, dataType: 'json',
    success: function() { 
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
  });
}
function removeGiftWraper() {
  data = { updates: { '42315027513497': 0 } }
  $.ajax({
    type: 'POST', url: '/cart/update.js', data: data, dataType: 'json',
    success: function() { 
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
  });
}




$(document).on('change', '#giftWrap', function(event){
    if (event.target.checked) {
      addGiftWraper();
    } else {
      removeGiftWraper();
    }
  });
